import React from 'react';
import { useIntl } from 'react-intl';

/**
 * Franja de "resultados de búsqueda" con reset.
 *
 * Es el bloque verde que hoy está copiado inline en ~27 grillas (mismo markup y el
 * mismo #5AAC43 repetido en cada archivo). Acá queda una sola vez.
 *
 * Se apoya en la clase global `.resultados-busqueda-notif` de assets/css/styles.css
 * (que aporta el hover más claro), igual que las copias inline.
 *
 * Va dentro de una columna del row `dt-icons` del toolbar de la grilla. El toolbar
 * debe tener TRES columnas de igual ancho (`col`): botones / franja / botones de
 * DataTables. Con `col-6 + col + col-6` se pasa de 12 y el bloque de la derecha
 * se va a la línea siguiente.
 *
 * @param visible   Mostrarla o no (típicamente: "hay una búsqueda activa").
 * @param mostrados Filas visibles en la página actual.
 * @param total     Total de resultados que informa el backend.
 * @param onReset   Handler de la "x". Debe dejar la grilla en su estado por defecto.
 */
const VERDE = '#5AAC43';

const GridSearchResultsBadge = (props) => {
	const intl = useIntl();

	if (!props.visible) return null;

	const texto = intl.formatMessage(
		{
			id: props.messageId || 'grid.resultados_busqueda',
			defaultMessage: props.defaultMessage || '{count} de {total} resultados de búsqueda',
		},
		{ count: props.mostrados, total: props.total }
	);

	return (
		<div className="btn-dt-main round-icon">
			<div
				className="text-center"
				style={{
					height: '25px',
					borderRadius: '3px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					paddingLeft: '8px',
					backgroundColor: VERDE,
					color: 'white',
				}}
			>
				<div className="text-center" style={{ width: '100%', fontSize: '12px', fontWeight: '500' }}>
					{texto}
				</div>
				<div className="resultados-busqueda-notif">
					<i className="las la-times la-xs cursor-pointer" onClick={() => props.onReset && props.onReset()}></i>
				</div>
			</div>
		</div>
	);
};

export default GridSearchResultsBadge;
